<template>
  <div v-if="(type === 'text' || type === 'email' || type === 'color' || type === 'password') && (input_style === 'oneLine' || (!input_style && !withoutLabel))" class="form-group first-type">
    <label :for="code" :class="' col-form-label  '+(required?'required':'')">{{label}}</label>
    <div class="item">
      <input class="form-control"
             :name="name"
             v-model="value"
             :type="type" :placeholder="placeholder" :id="code">
    </div>
  </div>
  <div v-if="(type === 'text' || type === 'email' || type === 'color' || type === 'password') && (input_style === 'twoLine' || (!input_style && withoutLabel))" class="form-group">
    <label v-if="!withoutLabel" :for="code" :class="'col-form-label'+(required?'required':'')">{{label}}</label>
    <input :type="type" class="form-control" :name="name" :id="code"
           v-model="value"
           :placeholder="placeholder">
  </div>
  <div v-else-if="type === 'textarea'  && (input_style === 'oneLine' || (!input_style && !withoutLabel))" class="form-group first-type">
    <label :for="code" :class="' col-form-label  '+(required?'required':'')">{{label}}</label>
    <div class="item">
      <textarea :name="name" class="form-control"
                v-model="value"
                :placeholder="placeholder" :id="code">{{value}}</textarea>
    </div>
  </div>
  <div v-else-if="type === 'textarea'  && (input_style === 'twoLine' || (!input_style && withoutLabel))" class="form-group">
    <label v-if="!withoutLabel" :for="code" :class="'col-form-label '+(required?'required':'')">{{label}}</label>
    <textarea
        v-model="value"
        :name="name" class="form-control" :placeholder="placeholder" :id="code">{{value}}</textarea>
  </div>
  <div v-else-if="type === 'number' && (input_style === 'oneLine' || (!input_style && !withoutLabel))" class="form-group first-type">
    <label :for="code" :class="' col-form-label  '+(required?'required':'')">{{label}}</label>
    <div class="item">
      <NumberInput :name="name" v-model="value" :placeholder="placeholder"></NumberInput>
    </div>
  </div>
  <div v-else-if="type === 'number'  && (input_style === 'twoLine' || (!input_style && withoutLabel))" class="form-group">
    <label v-if="!withoutLabel" :for="code" :class="'col-form-label '+(required?'required':'')">{{label}}</label>
    <NumberInput :name="name" v-model="value" :value="value"></NumberInput>
  </div>
  <div v-else-if="type === 'select' && (input_style === 'oneLine' || (!input_style && !withoutLabel))" class="form-group first-type">
    <label :for="code" :class="' col-form-label  '+(required?'required':'')">{{label}}</label>
    <div class="item">
      <div v-if="reduce_select && Array.isArray(value)">
        <input class="d-none" hidden v-for="(item,index) in value" :key="index" type="hidden" v-model="(item[reduce_select])" readonly :name="name">
      </div>
      <div v-else-if="Array.isArray(value) && !reduce_select">
        <input class="d-none" hidden v-for="(item,index) in value" :key="index" type="hidden" v-model="(item)" readonly :name="name">
      </div>
      <div v-else-if="!Array.isArray(value) && !reduce_select">
        <input type="hidden" class="d-none" hidden :value="(value)" readonly :name="name">
      </div>
      <div v-else>
        <input class="d-none" hidden type="hidden" :value="(value?value[reduce_select]:'')" readonly :name="name">
      </div>
      <v-select :append-to-body="!notSelectAppendToBody"
                :deselectFromDropdown="select_multiple"
                :closeOnSelect="!select_multiple"
                @search="customFetchOptions"
                v-model="value"
                :multiple="(!!select_multiple)" dir="rtl"
                :options="selectOptions" :label="selectLabel" :placeholder="placeholder"></v-select>
    </div>
  </div>
  <div v-else-if="type === 'select'  && (input_style === 'twoLine' || (!input_style && withoutLabel))" class="form-group mb-0">
    <label v-if="!withoutLabel" :for="code"  :class="'col-form-label '+(required?'required':'')">{{label}}</label>
    <div v-if="reduce_select && Array.isArray(value)">
      <input class="d-none" hidden v-for="(item,index) in value" :key="index" type="hidden" v-model="(item[reduce_select])" readonly :name="name">
    </div>
    <div v-else-if="Array.isArray(value) && !reduce_select">
      <input class="d-none" hidden v-for="(item,index) in value" :key="index" type="hidden" v-model="(item)" readonly :name="name">
    </div>
    <div v-else-if="!Array.isArray(value) && !reduce_select">
      <input type="hidden" class="d-none" hidden :value="(value)" readonly :name="name">
    </div>
    <div v-else>
      <input class="d-none" hidden type="hidden" :value="(value?value[reduce_select]:'')" readonly :name="name">
    </div>
    <v-select              :append-to-body="!notSelectAppendToBody"
              :deselectFromDropdown="select_multiple"
              :closeOnSelect="!select_multiple"
              @search="customFetchOptions"
              v-model="value"
              :multiple="(!!select_multiple)" dir="rtl"
              :options="selectOptions" :label="selectLabel" :placeholder="placeholder"></v-select>
  </div>
  <div v-else-if="type === 'date' && (input_style === 'oneLine' || (!input_style && !withoutLabel))" class="form-group first-type">
    <label :for="code" :class="' col-form-label  '+(required?'required':'')">{{label}}</label>
    <div class="item">
      <date-picker
          :format="dateTime?'jYYYY/jMM/jDD HH:mm':'jYYYY/jMM/jDD'"
          locale="fa"
          simple
          v-model="value"
          dir="rtl"
          :placeholder="placeholder"
          :type="(dateTime?'datetime':'date')"
          :name="name"
          :display-format="dateTime?'jYYYY/jMM/jDD HH:mm':'jYYYY/jMM/jDD'"
      />
    </div>
  </div>
  <div v-else-if="type === 'date' && (input_style === 'twoLine' || (!input_style && withoutLabel))">
    <label v-if="!withoutLabel" :for="code" :class="'col-form-label'+(required?'required':'')">{{label}}</label>
    <date-picker
        :format="dateTime?'jYYYY/jMM/jDD HH:mm':'jYYYY/jMM/jDD'"
        locale="fa"
        simple
        v-model="value"
        dir="rtl"
        :placeholder="placeholder"
        :type="(dateTime?'datetime':'date')"
        :name="name"
        :display-format="dateTime?'jYYYY/jMM/jDD HH:mm':'jYYYY/jMM/jDD'"
    />
  </div>
</template>

<script>
import vSelect from 'vue-select'
import {makeCode} from "@/shared/helper";
import NumberInput from "@/components/NumberInput";
import Vue3PersianDatetimePicker  from 'vue3-persian-datetime-picker';

export default {
  name: "CustomInput",
  components: {NumberInput,vSelect,DatePicker: Vue3PersianDatetimePicker },
  props:['input_style','label', 'placeholder','type','name','required','class','notSelectAppendToBody',
  'selectOptions','selectLabel','modelValue','reduce_select','select_multiple','dateTime','fetchOptions','withoutLabel','loopId'],
  emits: ['update:modelValue','change'],
  mounted()
  {
  },

  data(){
    return {
      code :'t'+makeCode(8),
      displaySelectedDate: '',
    }
  },
  methods:{
    customFetchOptions(search,loading)
    {
      if (typeof this.fetchOptions!=="function")
        return;
      if (typeof this.loopId!=="undefined" || this.loopId!=null)
        this.fetchOptions(this.loopId,search,loading);
      else
        this.fetchOptions(search,loading);
    },
  },
  computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  // watch:{
  //   'modelValue':{
  //     handler(){
  //       console.log(this.modelValue)
  //     },deep:true
  //   }
  // }
}
</script>

<style>
.vs__search::placeholder
{
  font-size: 13px!important;
}
</style>
<style scoped>
input::placeholder,textarea::placeholder
{
  font-size: 13px!important;
}

.first-type {
  display: flex;
  justify-content: flex-start;
  grid-column-gap: 12px;
}

.first-type .col-form-label
{
  width: 60px;
  flex: 0 0 60px;
}
.first-type .item
{
  width: 100%;
}

</style>